import { Box, Text } from "@chakra-ui/layout";
import { UnidadeForm } from "features/unidades/typings/unidade";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import useUnidade from "features/unidades/useUnidade";
import FormUnidade from "./FormUnidade";
import { showErrorAxios } from "infra/helpers/alerta";
import useSaveUnidade from "features/unidades/useSaveUnidade";
import { TipoEstruturaMoradiaEnum } from "resources/enums/tenant";
import Button from "components/Button";
import PrimaryButton from "components/Button/PrimaryButton";
import { useLoading } from "components/GlobalLoading";

interface FormCadastroUnidadeGeralProps {
  id?: string;
  tipoEstruturaMoradia: TipoEstruturaMoradiaEnum;
  tenantId: string;
  onClose: () => any;
  onSaved: (id: string) => any;
}

function FormCadastroUnidadeGeral({
  id,
  tipoEstruturaMoradia,
  tenantId,
  onClose,
  onSaved,
}: FormCadastroUnidadeGeralProps) {
  const { mutate: handleSave, isLoading: isLoadingSave } = useSaveUnidade(
    id,
    tenantId
  );

  const handleModalSubmit = async (data: UnidadeForm) => {
    handleSave(data, {
      onSuccess: (result) => {
        onSaved(result.data.id);
      },
      onError: (err) => {
        showErrorAxios(err);
      },
    });
  };

  const { control, handleSubmit, formState, reset } = useForm<UnidadeForm>({
    reValidateMode: "onChange",
    mode: "onTouched",
  });

  const { data, isLoading } = useUnidade(id);

  useLoading(isLoading || isLoadingSave);

  useEffect(() => {
    reset({});
  }, [reset]);

  useEffect(() => {
    if (data) {
      const form = {
        ...data,
        gruposUnidadesIds: data.gruposUnidades?.map((g) => g.id) || [],
      };

      reset(form);
    }
  }, [data, reset]);

  return (
    <form onSubmit={(ev) => handleSubmit(handleModalSubmit)(ev)}>
      <>
        <Text as="h3" fontSize={20}>
          {id ? "Editar" : "Cadastrar nova"} unidade
        </Text>

        <Box pt="16px">
          <FormUnidade
            tipoEstruturaMoradia={tipoEstruturaMoradia}
            tenantId={tenantId}
            control={control}
            isEdit={!!id}
          />
        </Box>

        <Box>
          <Box
            display="flex"
            gridGap={6}
            justifyContent="flex-end"
            flex={1}
            mt={8}
          >
            <Button onClick={onClose}>Cancelar</Button>

            <PrimaryButton
              type="button"
              isLoading={isLoadingSave}
              onClick={handleSubmit(handleModalSubmit)}
              disabled={!formState.isValid}
              minWidth={"120px"}
            >
              Salvar
            </PrimaryButton>
          </Box>
        </Box>
      </>
    </form>
  );
}

export default FormCadastroUnidadeGeral;
